import axios from 'axios';
import { BehaviorSubject } from 'rxjs';

class EtvService {
  public config: BehaviorSubject<any> = new BehaviorSubject(undefined);

  private initDone: boolean = false;

  private getConfigInterval = 50000; // 50sec
  private getConfigTimer: any;

  private token: string = '';

  public init(token: string) {
    return new Promise((resolve, reject) => {
      this.token = token;

      this.getPlayerConfig(token)
        .then((res) => {
          if (!this.initDone) {
            this.initDone = true;
            resolve(this.config);
            this.config.next(res.data);
            this.startGetConfigInterval(token);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * https://livecloud-beta.earthtv.com/api/v1/doc#operation/mediaGetPlayerConfig
   */
  public getPlayerConfig(token: string) {
    return axios({
      method: 'get',
      url: process.env.VUE_APP_API_PATH + '/media.getPlayerConfig?playerToken=' + token,
      headers: {
        Accept: 'application/json',
      },
    });
  }

  /**
   * https://livecloud-beta.earthtv.com/api/v1/search.searchMedia?token={{player_token}}
   */
  public getPlaylist(playlistId: string, token: string, query: any, sortField: any, sortOrder: any, limit: number, offset: number) {
    const postData = {
      playlistId,
      query: 'medium.maintenance = false AND medium.status = finished',
      relations: ['medium', 'variants', 'source'],
      types: ['clip'],
      offset: offset ? Number(offset) : 0,
      limit: limit ? Number(limit) : 100,
      sort: [
        {
          field: 'medium.startTime',
          order: 'desc',
        },
      ],
    };

    if (sortField) {
      // @ts-ignore
      postData.sort[0].field = sortField;
    }

    if (sortOrder) {
      // @ts-ignore
      postData.sort[0].order = sortOrder;
    }

    if (query) {
      postData.query = query;
    }

    return axios({
      method: 'post',
      url: process.env.VUE_APP_API_PATH + '/search.searchMedia',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: postData,
    });
  }

  public reload() {
    return new Promise<void>((resolve, reject) => {
      this.getPlayerConfig(this.token)
        .then((res) => {
          if (res.data) {
            this.config.next(res.data);
          }
          this.startGetConfigInterval(this.token);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  private startGetConfigInterval(token: string) {
    if (this.getConfigTimer) {
      clearInterval(this.getConfigTimer);
    }

    this.getConfigTimer = setInterval(() => {
      this.getPlayerConfig(token).then((res) => {
        if (res.data) {
          this.config.next(res.data);
        }
      });
    }, this.getConfigInterval);
  }
}

export const etvService = new EtvService();
